<template>
  <div v-loading="loading" class="success">
    <img src="../../assets/Success.png" alt />
    <span>{{ $t("message.apply_success") }}</span>
    <span id="preview_message">{{ message }}</span>
    <!-- <GradientBtn style="margin-top:24px;" @click="back">{{$t('message.back')}}</GradientBtn> -->
  </div>
</template>

<script>
import ApplicationAPI from "../../api/ApplicationAPI";
import HzmbApplicationAPI from "../../api/HzmbApplicationAPI";
import LoginAPI from "../../api/LoginAPI";
import ServiceTypeConfigAPI from "../../api/ServiceTypeConfigAPI";
import GradientBtn from "../../components/GradientBtn";
import { wordBreak } from "@/filters";
export default {
  components: { GradientBtn },
  data() {
    return {
      loading: false,
      message: "",
    };
  },
  computed: {
    applicantType() {
      const serviceType = this.$store.state.serviceType;
      return serviceType == "HZMB_FIRST_PERSON" ||
        serviceType == "HZMB_RENEW_PERSON"
        ? "PERSON"
        : "COMPANY";
    },
  },
  methods: {
    // 獲取通知訊息
    getMessage(id, serviceType, messageType) {
      this.loading = true;
      HzmbApplicationAPI.message(id, serviceType, messageType, {})
        .then((res) => {
          this.loading = false;
          this.message = res[this.$t("message.lang")];
          localStorage.setItem("previewMessage", res[this.$t("message.lang")]);
          this.logout();
          // console.log(res);
        })
        .catch((err) => {
          this.loading = false;
          this.logout();
          this.$error(err);
        });
    },
    logout() {
      this.loading = true;
      LoginAPI.logout()
        .then((res) => {
          this.loading = false;
          var form = {
            quota: {
              macauAddress: {
                textCn: "",
                textPt: "",
              },
            },
            vehicle: {},
            cheque: {},
            drivers:
              this.applicationType == "FIRST"
                ? [
                    {
                      macauAddress: {
                        textCn: "",
                        textPt: "",
                      },
                    },
                  ]
                : [],
          };
          localStorage.setItem("form", "");
          this.$store.commit("updateForm", form);
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
    getServiceTypeDetail() {
      const serviceType = localStorage.getItem("serviceType") || null;
      this.loading = true;
      ServiceTypeConfigAPI.getDetails(serviceType)
        .then((res) => {
          this.loading = false;
          res.nameTc = wordBreak(res.nameTc);
          res.nameSc = wordBreak(res.nameSc);
          res.namePt = wordBreak(res.namePt);
          res.nameEn = wordBreak(res.nameEn);
          this.$store.commit("changeServiceTypeConfig", res);
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
    back() {
      const childTempTitle = localStorage.getItem("childTempTitle") || null;
      if (childTempTitle == "two") {
        this.$router.push("/entryBus");
      } else {
        this.$router.push("/entry");
      }
    },
  },
  created() {
    const serviceType = localStorage.getItem("serviceType") || null;
    const verifyForm = localStorage.getItem("verifyForm")
      ? JSON.parse(localStorage.getItem("verifyForm"))
      : null;
    const spNo = verifyForm.spNo || null;
    const registrationNo = verifyForm.registrationNo || null;
    const identificationNo = verifyForm.identificationNo || null;
    const previewMessage = localStorage.getItem("previewMessage") || null;
    if (serviceType) {
      this.loading = true;
      ApplicationAPI.getBySpOrReg(
        serviceType,
        spNo,
        registrationNo,
        identificationNo
      )
        .then((res) => {
          this.loading = false;
          this.getServiceTypeDetail();
          if (res.id && !previewMessage) {
            this.getMessage(
              res.id,
              res.serviceType,
              res.status === "SUBMITTED" ? "SUBMITTED_VIEW" : res.status
            );
          } else {
            this.message = previewMessage;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    }
  },
};
</script>

<style lang="scss" scoped>
// .success {
//   height: 700px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   max-width: 600px;
//   margin: auto;
//   text-align: center;
// }
// .success img {
//   width: 96px;
//   height: auto;
//   margin-bottom: 36px;
// }
// .success span {
//   font-size: 24px;
//   color: #515151;
//   line-height: 33px;
// }
</style>
